export const VIDEO_TUTORIAL = '/video_tutorial/all'
